
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-to-watch/web",
      function () {
        return require("private-next-pages/how-to-watch/web/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-to-watch/web"])
      });
    }
  